<template>
  <div class="sample-page">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>就诊流程</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="page-handle">
      <div class="left">
        <a-button v-auth="'10201'" @click="add()" type="primary">申请单录入</a-button>
        <a-button v-auth="'10202'" @click="batchAddClick()" type="primary">批量申请单录入</a-button>
        <template>
          <a-popover overlayClassName="export-popover" placement="bottomLeft" title="请选择" v-model="popoverVisible"
            trigger="click">
            <template slot="content">
              <div class="export-content">
                <a-select class="tool-item" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  :disabled="sequencingStatus" v-model="deptId" placeholder="请选择测序中心">
                  <a-select-option :key="item.deptId" v-for="item in sequencingData" :value="item.deptId + ''">{{
                    item.deptName }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="export-content">
                <a-range-picker class="tool-item" @change="onChangePicker" :value="rPrckerVal" />
                <a-button class="export-btn" type="primary" @click="exportFile" v-auth="'10229'">导出
                </a-button>
              </div>
            </template>
            <a-button type="primary" v-auth="'10229'">导出 API_LOG</a-button>
          </a-popover>
        </template>
        <a-button v-auth="'10231'" @click="exportExcelClick()" type="primary">导出列表</a-button>
        <a-button v-auth="'10203'" @click="sureClick()">确认</a-button>
        <a-button v-auth="'10204'" @click="insertClick()">样本入库</a-button>
      </div>
      <div class="right">
        <a-input-search v-model="hosBarCodeOrBarCode" @search="onSearch" placeholder="输入协作组条码/测序中心条码/患者姓名"
          style="width: 300px" />
        <a-tooltip placement="bottomRight">
          <template slot="title"> fq/idat未在规定时间范围内上传成功 </template>
          <a-checkable-tag class="cktag-warnig" v-model="warning" button-style="solid" @change="ckWarning">提醒
          </a-checkable-tag>
        </a-tooltip>
        <a class="filter-btn" @click="drawerVisible = true">筛选
          <a-icon type="filter" />
        </a>
        <a-drawer title="筛选" :width="600" placement="right" :closable="false" :visible="drawerVisible" @close="onClose"
          :body-style="{ paddingBottom: '80px' }">
          <div class="filter-drawer-content">
            <div class="filter-drawer-title">
              就诊医院
              <a-icon type="right" />
              <span class="filter-dt-prompt">多选</span>
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="hospitalAll ? 'primary' : 'default'" @click="searchCheckbox(null, hospitalOption)">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in hospitalData" :key="item.keyId">
                <a-button :type="
                  hospitalId.indexOf(item.keyId) > -1 ? 'primary' : 'default'
                " @click="searchCheckbox(item, hospitalOption)">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              测序中心
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="!seqDeptId ? 'primary' : 'default'"
                  @click="handleSequenceFilterStatClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in sequenceFilterStat" :key="item.keyId">
                <a-button :type="seqDeptId == item.keyId ? 'primary' : 'default'"
                  @click="handleSequenceFilterStatClick({ key: item.keyId })">
                  {{ item.value || '-' }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              跟踪状态
              <a-icon type="right" />
              <span class="filter-dt-prompt">多选</span>
            </div>
            <a-row>
              <a-col :span="8">
                <a-button :type="operateStatusALL ? 'primary' : 'default'" @click="searchCheckbox(null, operateOption)">
                  全部
                </a-button>
              </a-col>
              <a-col :span="8" v-for="item in smallStatus" :key="item.keyId">
                <a-button :type="
                  trackingStatus.indexOf(item.keyId) > -1
                    ? 'primary'
                    : 'default'
                " @click="searchCheckbox(item, operateOption)">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
           
            <div class="filter-drawer-title">
              MD审核状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!mdCheck ? 'primary' : 'default'" @click="checkMdCheckStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in mdCheckData" :key="item.key">
                <a-button :type="mdCheck == item.key ? 'primary' : 'default'"
                  @click="checkMdCheckStatus({ key: item.key })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              MD已读
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!mdRead ? 'primary' : 'default'" @click="checkMdReadStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in mdReadList" :key="item.keyId">
                <a-button :type="mdRead == item.keyId ? 'primary' : 'default'"
                  @click="checkMdReadStatus({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              检测项目
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!applyItem ? 'primary' : 'default'" @click="checkApplyItem({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in commonDictData" :key="item.keyId">
                <a-button :type="applyItem == item.keyId ? 'primary' : 'default'"
                  @click="checkApplyItem({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            
            <div class="filter-drawer-title">
              患者组
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!patientGroupId ? 'primary' : 'default'" @click="handleGroupClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in dataGroup" :key="item.id">
                <a-button :type="patientGroupId == item.id ? 'primary' : 'default'"
                  @click="handleGroupClick({ key: item.id })">
                  {{ item.groupName }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              质控状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!qualityStatus ? 'primary' : 'default'" @click="handleQualityClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in qualityData" :key="item.keyId">
                <a-button :type="qualityStatus == item.keyId ? 'primary' : 'default'"
                  @click="handleQualityClick({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }">
            <a-button style="margin-right: 8px" @click="resetDrawer">重置</a-button>
            <a-button type="primary" @click="okDrawer"> 确定 </a-button>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="page-content">
      <a-spin :spinning="spinning">
        <a-table class="hospital-table" :pagination="false" :rowSelection="rowSelection" :columns="columns"
          :dataSource="data" @change="handleTableChange" :customRow="rowClick" :rowClassName="setRowClassName"
          :rowKey="(record) => record.id" size="middle">
          <span slot="number" slot-scope="text, record, index">{{
            (page - 1) * pageSize + index + 1
          }}</span>
          <router-link slot="barCode" slot-scope="text, record"
            :to="{ path: 'diagnosis/details', query: { id: record.id } }">{{ text }}
          </router-link>
          <template slot="warningStatus" slot-scope="text, record">
            <a-tag v-if="record.warningHours !== 0" :color="record.warningStatus === '临近' ? 'orange' : '#f50'">
              {{ record.warningStatus }}
            </a-tag>
            <a-tag v-else color="#87d068">正常</a-tag>
          </template>
          <template slot="mdCheck" slot-scope="text, record">
            <md-to-popinfo :itemId="record.id" :recordItem="record" :authCode="10230" @updateRows="updateRows"
              @updateRowsPop="updateRowsPop"></md-to-popinfo>
          </template>
          <div slot-scope="text, record" slot="qualityStatusDict">
            <span v-if="record.qualityStatus != 2 && text != null">{{
              text
            }}</span>
            <span v-else-if="record.qualityStatus != 2 && text == null">-</span>
            <a-popover v-else title="原因">
              <div style="max-width: 300px" slot="content">
                {{ record.qualityRemark }}
              </div>
              <span class="link">{{ text }}</span>
            </a-popover>
          </div>
          <div slot-scope="text, record, index" class="table-tr-handle" slot="handle">
            <!--:style="{opacity:record.trackingStatus=='confirmed-requisition'||record.trackingStatus=='added-item'||record.trackingStatus=='deleted-item'||record.trackingStatus=='wait-add-item'||record.trackingStatus=='canceled-requisition'?1:0.2,cursor:record.trackingStatus=='added-item'||record.trackingStatus=='deleted-item'||record.trackingStatus=='wait-add-item'||record.trackingStatus=='canceled-requisition'?'pointer':'not-allowed'}"-->
            <span v-auth="'10206'" @click="editRows($event, record, index)" class="handle-btn">编辑</span>
            <span v-auth="'10206'" class="handle-line">|</span>
            <span v-show="false">
              <input type="file" :id="'upload_' + record.id" />
            </span>
            <span class="handle-more">
              <a-dropdown :trigger="['click']" overlayClassName="hospital-dropdown-table" class="hospital-dropdown-link">
                <a class="ant-dropdown-link">
                  <i class="icon-gengduo iconfont"></i>
                </a>
                <a-menu @click="(event) => menuClick(event, record)" slot="overlay">
                  <a-menu-item v-auth="'10210'" v-if="
                    record.trackingStatus == 'wait-add-item' ||
                    record.trackingStatus == 'deleted-item'
                  " key="3">
                    <span>增项</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10203'" v-if="record.trackingStatus == 'added-item'" key="7">
                    <span>确认</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10211'" v-if="record.trackingStatus == 'added-item'"
                    key="returnIncrement|confirmData">
                    <span>退项</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10225'" v-if="record.trackingStatus == 'report-uploaded'" key="8">
                    <span>申请退回</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10226'" v-if="record.trackingStatus == 'report-uploaded'" key="9">
                    <span>确认完成</span>
                  </a-menu-item>
                  <!-- <a-menu-item
                    v-if="record.trackingStatus=='wait-add-item'||record.trackingStatus=='added-item'||record.trackingStatus=='confirmed-requisition'"
                    key="cancelApply|confirmData"
                  >
                    <span>取消申请单</span>
                  </a-menu-item>
                  <a-menu-item
                    v-if="record.trackingStatus=='canceled-requisition'"
                    key="recoveryApply|confirmData"
                  >
                    <span>恢复申请单</span>
                  </a-menu-item>-->
                  <a-menu-item v-auth="'10214'" v-if="record.trackingStatus == 'confirmed-requisition'"
                    key="canceSure|confirmData">
                    <span>取消确认</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10217'" v-if="record.trackingStatus == 'confirmed-requisition'"
                    key="specimenHandover|confirmData">
                    <span>标本交接</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10218'" v-if="record.trackingStatus == 'handover'"
                    key="specimenReceive|confirmData">
                    <span>标本接收</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10215'" v-if="record.trackingStatus == 'experiment'"
                    key="operateComputer|confirmData">
                    <span>上机</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10216'" v-if="record.trackingStatus == 'already-up-compute'"
                    key="downComputer|confirmData">
                    <span>下机</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10228'" v-if="upFqStatus.indexOf(record.trackingStatus) > -1" key="11">
                    <span>上传MD5</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10207'" v-if="upFqStatus.indexOf(record.trackingStatus) > -1" key="upload">
                    <span>上传fq/idat</span>
                  </a-menu-item>
                  <!-- key="stopComputer|confirmData" -->
                  <!-- running -->
                  <!--v-if="record.trackingStatus=='wait-add-item'||record.trackingStatus=='added-item'||record.trackingStatus=='confirmed-requisition'||record.trackingStatus=='handover'||record.trackingStatus=='experiment'||record.trackingStatus=='already-up-compute'||record.trackingStatus=='fq-to-be-uploaded'"-->
                  <a-menu-item v-auth="'10212'" v-if="
                    record.trackingStatus != 'done' &&
                    record.trackingStatus != 'running' &&
                    record.trackingStatus != 'qc'
                  " key="5">
                    <span>终止流程</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10213'" v-if="record.trackingStatus == 'flow-canceled'"
                    key="resetComputer|confirmData">
                    <span>恢复流程</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10208'" v-if="
                    qualityShow(record) &&
                    record.trackingStatus != 'flow-canceled'
                  " key="4">
                    <span>质控</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10227'" v-if="record.trackingStatus == 'to-be-filter'" key="10">
                    <span>重传fq/idat</span>
                  </a-menu-item>
                  <a-menu-item v-auth="'10208'" key="6">
                    <span>常规结果</span>
                  </a-menu-item>
                  <a-menu-item key="12">
                    <span>备注</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
            <!-- <span @click="deleteDiagnosis(record)" class="handle-btn">删除</span> -->
          </div>
        </a-table>
      </a-spin>
      <div class="pagination">
        <a-pagination @change="pageChange" :pageSize.sync="pageSize" v-model="page" size="small" :total="resData.total" />
      </div>
    </div>
    <page-model @close="closeModel" :visible="visible">
      <!-- 批量添加 -->
      <batch-add @close="closeModel" v-if="visible && modelId == 0"></batch-add>
      <!-- 添加 -->
      <d-add :editData="selectData" v-if="visible && modelId == 1" @close="closeModel"></d-add>
      <!-- 样本入库 -->
      <d-insert v-if="visible && modelId == 2" :list="selectRows" @close="closeModel"></d-insert>
      <!-- 增项 -->
      <d-increment @ok="incrementClick" :iData="selectData" v-if="visible && modelId == 3" @close="closeModel">
      </d-increment>
      <!-- 质控 -->
      <quality-control v-if="visible && modelId == 4" :data="selectData" @close="closeModel"></quality-control>
      <q-end v-if="visible && modelId == 5" :data="selectData" @close="closeModel"></q-end>
      <!-- 常规结果  -->
      <c-results v-if="visible && modelId == 6" :data="selectData" @close="closeModel"></c-results>
      <!-- 申请退回 -->
      <review v-if="visible && modelId == 8" :data="selectData" @close="closeModel"></review>
      <finish v-if="visible && modelId == 9" :data="selectData" @close="closeModel"></finish>
      <again-upload-fq v-if="visible && modelId == 10" :data="selectData" @close="closeModel"></again-upload-fq>
      <md5 v-if="visible && modelId == 11" :data="selectData" @close="closeModel"></md5>
      <remark v-if="visible && modelId == 12" :data="selectData" @close="closeModel"></remark>
    </page-model>
    <!-- 二次弹窗 -->
    <h-confirm :visible="confirmVisible" @close="closeConfirm" :loadding.sync="confirmLoadding" @ok="okClick"
      :title="currentConfirmData.title" :content="currentConfirmData.content" :desc="currentConfirmData.desc">
    </h-confirm>
  </div>
</template>

<script>
import BatchAdd from "./batchAdd.vue";
import DAdd from "./add.vue";
import DInsert from "./insert.vue";
import DIncrement from "./increment.vue";
import QualityControl from "./qualityControl.vue";
import QEnd from "./end.vue";
import CResults from "./conventionalResults";
import auth from "../../directives/auth-utils";
import Review from "./review";
import Finish from "./finish";
import AgainUploadFq from "./againUploadFq";
import Md5 from "./md5";
import Remark from "./remark";
import MdToPopinfo from "../report/md-to-popinfo.vue";

const columns = [
  {
    title: "序号",
    scopedSlots: { customRender: "number" },
  },
  {
    title: "提醒",
    dataIndex: "warningStatus",
    scopedSlots: { customRender: "warningStatus" },
  },
  {
    title: "协作组条码",
    dataIndex: "hosBarCode",
  },
  {
    title: "测序中心条码",
    dataIndex: "barCode",
    scopedSlots: { customRender: "barCode" },
  },
  {
    title: "患者名称",
    dataIndex: "patientName",
  },
  {
    title: "性别",
    dataIndex: "sexName",
  },
  {
    title: "就诊医院",
    dataIndex: "hospitalName",
    width: "10%",
  },
  {
    title: "检测项目",
    dataIndex: "applyItemNameDict",
    customRender: (text, record, index) => {
      if (!record.applyItemNameDict) {
        return "-";
      } else {
        return record.applyItemNameDict;
      }
    },
  },
  {
    title: "分组",
    dataIndex: "patientGroupName",
    customRender: (text, record, index) => {
      if (!record.patientGroupName) {
        return "-";
      } else {
        return record.patientGroupName;
      }
    },
  },
  {
    title: "跟踪状态",
    dataIndex: "trackingStatusName",
  },
  {
    title: "质控状态",
    dataIndex: "qualityStatusDict",
    scopedSlots: { customRender: "qualityStatusDict" },
  },
  {
    title: "MD审核",
    dataIndex: "mdCheck",
    scopedSlots: { customRender: "mdCheck" },
  },
  {
    title: "采样日期",
    dataIndex: "sampleCollectionTime",
    sorter: true,
    customRender: (text, record, index) => {
      if (!record.sampleCollectionTime) {
        return "-";
      } else {
        return record.sampleCollectionTime;
      }
    },
  },
  {
    title: "录入时间",
    dataIndex: "createTime",
    sorter: true,
    customRender: (text, record, index) => {
      if (!record.createTime) {
        return "-";
      } else {
        return record.createTime;
      }
    },
    width: "8%",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    sorter: true,
    customRender: (text, record, index) => {
      if (!record.updateTime) {
        return "-";
      } else {
        return record.updateTime;
      }
    },
    width: "8%",
  },
  // {
  //   title: "门诊号",
  //   dataIndex: "patientNo"
  // },
  // {
  //   title: "出生日期",
  //   dataIndex: "ageBirthDay",
  //   customRender: (text, record, index) => {
  //     return text ? text.split(" ")[0] : "-";
  //   }
  // },
  // {
  //   title: "更新时间",
  //   dataIndex: "createTime",
  //   scopedSlots: {customRender: "createTime"}
  // },
  {
    title: "操作",
    scopedSlots: { customRender: "handle" },
  },
];
export default {
  data() {
    return {
      data: [],
      resData: {},
      fqData: [],
      dataGroup: [],
      groupTitle: "选择组",
      qualityTitle: "质控状态",
      selectRows: [],
      hospitalName: "就诊医院",
      confirmLoadding: false,
      statusText: "跟踪状态",
      mdCheckText: "MD审核状态",
      mdCheck: "",
      mdRead: "",
      applyItem: "",
      mdReadText: "MD已读",
      hospitalId: [],
      patientGroupId: "",
      qualityStatus: "",
      visible: false,
      confirmVisible: false,
      popoverVisible: false,
      sequencingData: [],
      sequencingStatus: false,
      rPrckerVal: null,
      deptId: undefined,
      dowmOpt: {
        startTime: null,
        endTime: null,
        formId: "",
      },
      columns,
      rows: null,
      rowsPop: false,
      spinning: false,
      currentConfirmData: {},
      confirmData: {
        sureData: {
          title: "就诊流程确认",
          content: "您确认患者基本信息和检测项目信息均正确吗？",
          desc: "",
          operateType: "confirmed-requisition",
        },
        returnIncrement: {
          title: "就诊流程退项",
          content: "您确认要退项吗？",
          desc: "",
          operateType: "deleted-item",
        },
        cancelApply: {
          title: "取消申请单",
          content: "您确认要取消申请单吗？",
          desc: "",
          operateType: "canceled-requisition",
        },
        recoveryApply: {
          title: "恢复申请单",
          content: "您确认要恢复申请单吗？",
          desc: "",
          operateType: "requisition-recovery",
        },
        canceSure: {
          title: "取消确认",
          content: "您确认要取消确认吗？",
          desc: "",
          operateType: "cancel-confirmed",
        },
        specimenHandover: {
          title: "标本交接",
          content: "您确认要标本交接吗？",
          desc: "",
          operateType: "sample-handover",
        },
        specimenReceive: {
          title: "标本接收",
          content: "您确认要标本接收吗？",
          desc: "",
          operateType: "sample-reception",
        },
        operateComputer: {
          title: "就诊流程上机",
          content: "您确认要上机吗？",
          desc: "",
          operateType: "up-computer",
        },
        downComputer: {
          title: "就诊流程下机",
          content: "您确认要下机吗？",
          desc: "",
          operateType: "already-down-compute",
        },
        stopComputer: {
          title: "就诊流程终止",
          content: "您确认要终止流程吗？",
          desc: "",
          operateType: "flow-canceled",
        },
        resetComputer: {
          title: "就诊流程恢复",
          content: "您确认要恢复流程吗？",
          desc: "",
          operateType: "recovery-process",
        },
      },
      page: 1,
      selectData: null,
      pageSize: 10,
      modelId: 0,
      hospitalData: [],
      commonDictData: [],
      uploadSuffixs: ["fastq.gz", "fq.gz", "vcf", "fastq", "fq", "idat"],
      trackingStatus: [],
      smallStatus: [],
      sequenceFilterStat: [],
      seqDeptId: '',
      warning: false,
      hosBarCodeOrBarCode: "",
      sortOrder: "",
      sortField: "",
      selectedRowKeys: [],
      operateStatusALL: false,
      hospitalAll: false,
      dropdownTVisible: false,
      dropdownHVisible: false,
      operateOption: {
        key: "keyId",
        value: "value",
        paramsKey: "trackingStatus",
        allFlag: "operateStatusALL",
        allData: "smallStatus",
      },
      hospitalOption: {
        key: "keyId",
        value: "value",
        paramsKey: "hospitalId",
        allFlag: "hospitalAll",
        allData: "hospitalData",
      },
      upFqStatus: [
        "fq-upload-cancel",
        "fq-to-be-uploaded",
        "waiting",
        "fq-uploading",
        "fq-upload-failed",
        "fq-upload-success",
        "done",
        "psudone",
        "failed",
        "cancel",
      ],
      qualityData: [],
      mdReadList: [],
      mdCheckData: [],
      drawerVisible: false,
    };
  },
  components: {
    BatchAdd,
    DAdd,
    DInsert,
    DIncrement,
    QualityControl,
    QEnd,
    CResults,
    Review,
    Finish,
    AgainUploadFq,
    Md5,
    Remark,
    MdToPopinfo,
  },
  watch: {
    drawerVisible(val, oldVal) {
      if (val) {
        this.getGroupList();

      }
    },
    reload(val) {
      if (val) {
        this.getData();
        this.$store.commit("file/setReload", false);
      }
    },
  },
  computed: {
    reload() {
      return this.$store.state.file.reload;
    },
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRows = selectedRows;
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    },
  },
  mounted() {
    this.currentConfirmData = this.confirmData.sureData;
    this.getStorage();
    this.gethospital();
    this.getSequenceFilterStat();
    // this.getBaseInfo();
    this.getSmallStatus();
    this.gethospitalLog();
    this.getMDCheckValue();
    this.getMDReadValue();
    this.getQualityFilterStat();
    this.getCommonDict();
  },

  methods: {
    // 首次加载时获取缓存的列表筛选值
    getStorage() {
      if (localStorage.getItem("DIAGNOSIS_FILTER")) {
        const params = JSON.parse(localStorage.getItem("DIAGNOSIS_FILTER"));
        this.pageSize = params.pageSize;
        this.page = params.pageNum;
        this.hosBarCodeOrBarCode = params.hosBarCodeOrBarCode;
        this.patientGroupId = params.patientGroupId;
        this.qualityStatus = params.qualityStatus;
        // this.sortField = params.sortField;
        // this.sortOrder = params.sortOrder;
        this.hospitalId = params.hospitalId ? params.hospitalId : [];
        this.trackingStatus = params.trackingStatus
          ? params.trackingStatus
          : [];
        this.warning = params.warning;
        this.mdCheck = params.mdCheck;
        this.mdRead = params.mdRead;
        this.seqDeptId = params.seqDeptId;
        this.applyItem = params.applyItem;
        if (this.qualityStatus) {
          this.handleQualityClick({ key: this.qualityStatus }, true);
        }
        if (this.mdCheck) {
          this.checkMdCheckStatus({ key: this.mdCheck }, true);
        }
      }
      this.getData();
    },
    // 首次加载时 设置已选中状态
    // selectedId:已选id-[],selectedData:所有数据-[],key:接口数据中对应的id-'',allFlag:全选-bool
    setSelected(selectedId, selectedData, key, allFlag) {
      selectedId = this[selectedId];
      if (!selectedId) {
        return false;
      }
      selectedData = this[selectedData];
      if (selectedId.length) {
        selectedData.forEach(function (item) {
          if (selectedId.indexOf(item[key]) > -1) {
            item.isSelected = true;
          } else {
            item.isSelected = false;
          }
        });
      } else {
        this[allFlag] = true;
      }
    },
    onClose() {
      this.drawerVisible = false;
    },
    resetDrawer() {
      this.page = 1;
      this.patientGroupId = "";
      this.qualityStatus = "";
      this.mdCheck = "";
      this.mdRead = "";
      this.applyItem = "";
      this.seqDeptId = "";
      this.trackingStatus = [];
      this.hospitalId = [];
      this.operateStatusALL = true;
      this.hospitalAll = true;
      this.getData();
    },
    okDrawer() {
      this.page = 1;
      this.drawerVisible = false;
      this.getData();
    },
    getMDCheckValue() {
      this.mdCheckData = [];
      this.$get("md/getMDCheckValue", { module: 2 }).then((res) => {
        this.mdCheckData = res.data.data;
      });
    },
    getMDReadValue() {
      this.mdReadList = [];
      this.$get("md/getMDReadValue", { module: 2 }).then((res) => {
        this.mdReadList = res.data.data;
      });
    },
    getQualityFilterStat() {
      this.qualityData = [];
      this.$get("patientitem/patientItem/getQualityFilterStat").then((res) => {
        this.qualityData = res.data.data;
      });
    },
    // 获取分组
    getGroupList() {
      this.dataGroup = [];
      this.$get("patientgroup", { module: 2 }).then((res) => {
        this.dataGroup = res.data.data;
        if (this.patientGroupId) {
          this.handleGroupClick({ key: this.patientGroupId }, true);
        }
      });
    },
    // 表格分页、排序、筛选变化时触发
    handleTableChange(pagination, filters, sorter) {
      this.sortOrder = sorter.order;
      this.sortField = sorter.columnKey;
      this.getData();
    },
    rowClick(record, index) {
      let $this = this;
      return {
        on: {
          click: () => {
            this.rows = index;
          },
        },
      };
    },
    setRowClassName(record, index) {
      let className = "";
      if (index === this.rows && this.rowsPop) {
        className = "clickrowstyle";
      }
      return className;
    },
    // 选择组 查询
    handleGroupClick(e, bol) {
      if (e.key == "default") {
        this.groupTitle = "请选择";
        this.patientGroupId = "";
      } else {
        this.dataGroup.forEach((item, index) => {
          if (item.id == e.key) {
            this.groupTitle = item.groupName;
            return;
          }
        });
        this.patientGroupId = e.key;
      }
    },
    // 选择组 查询
    handleQualityClick(e, bol) {
      if (e.key == "default") {
        this.qualityTitle = "质控状态";
        this.qualityStatus = "";
      } else {
        this.qualityData.forEach((item, index) => {
          if (item.key == e.key) {
            this.qualityTitle = item.value;
            return;
          }
        });
        this.qualityStatus = e.key;
      }
    },
    handleSequenceFilterStatClick(e) {
      if (e.key == "default") {
        this.seqDeptId = "";
      } else {
        this.seqDeptId = e.key;
      }

    },
    checkMdCheckStatus(e, bol) {
      if (e.key == "default") {
        this.mdCheckText = "MD审核状态";
        this.mdCheck = "";
      } else {
        this.mdCheckData.forEach((item, index) => {
          if (item.key == e.key) {
            this.mdCheckText = item.value;
            return;
          }
        });
        this.mdCheck = e.key;
      }
    },
    checkApplyItem(e) {
      if (e.key == "default") {
        this.applyItem = "";
      } else {
        this.commonDictData.forEach((item, index) => {
          if (item.dictKey == e.key) {
            return;
          }
        });
        this.applyItem = e.key;
      }
    },
    checkMdReadStatus(e) {
      if (e.key == "default") {
        this.mdReadText = "MD已读";
        this.mdRead = "";
      } else {
        this.mdReadList.forEach((item, index) => {
          if (item.key == e.key) {
            this.mdReadText = item.value;
            return;
          }
        });
        this.mdRead = e.key;
      }
    },
    getSequenceFilterStat() {
      this.$get("report/report/getSequenceFilterStat", { module: 2 }).then((res) => {
        this.sequenceFilterStat = res.data.data;
      });
    },
    // 跟踪状态
    getSmallStatus() {
      this.$get("report/report/getTrackingStatusFilterStat", { module: 2 }).then((res) => {
        this.smallStatus = res.data.data;
        this.setSelected(
          "trackingStatus",
          "smallStatus",
          "operateStatus",
          "operateStatusALL"
        );
      });
    },
    qualityShow(item) {
      return this.smallStatus.find(
        (d) => d.keyId == item.trackingStatus
      );
    },
    checkHospital(event) {
      this.hospitalName = event.item.value;
      this.hospitalId = event.key;
      this.getData();
    },
    // item 选中数据
    // option参数 key:接口数据中对应的id-'',value:页面显示的选项文字-'',paramsKey:列表接口需要的key名-'',allFlag:全选-bool,allData:所有数据-[]
    searchCheckbox(item, option) {
      const key = option.key,
        name = option.value,
        paramsKey = option.paramsKey,
        allFlag = option.allFlag,
        allData = option.allData;
      if (item) {
        item.isSelected = !item.isSelected;
        this[allFlag] = false;
        // this.statusText = item.value;
        if (item.isSelected) {
          this[paramsKey].push(item[key]);
        } else {
          this[paramsKey].splice(this[paramsKey].indexOf(item[key]), 1);
        }
        if (this[paramsKey].length == 0) {
          this[allFlag] = true;
        }
      } else {
        this[allFlag] = true;
        this[paramsKey] = [];
        this[allData].forEach(function (item) {
          item.isSelected = false;
        });
      }
    },
    ckWarning(e) {
      this.page = 1;
      this.getData();
    },
    getCommonDict() {
      this.$get("report/report/getApplyItemFilterStat", { module: 2 }).then((res) => {
        this.commonDictData = res.data.data;
      });
    },
    gethospital() {
      this.$get("report/report/findDeptStatList", { module: 2 }).then((res) => {
        this.hospitalData = res.data.data;
        this.setSelected("hospitalId", "hospitalData", "keyId", "hospitalAll");
      });
    },
    goToDetails(record) {
      if (auth.auth("10209")) {
        this.$router.push({
          path: "/diagnosis/details",
          query: {
            id: record.id,
          },
        });
      }
    },
    handleDiagnosis(item, type, callback) {
      // 申请单确认批量操作
      if (type == "confirmed-requisition") {
        this.$post(
          "patientitem/patientItem/patientItemConfirmationBatch?operateType=" +
          type,
          item,
          {
            "Content-Type": "application/json",
          }
        ).then(
          (res) => {
            this.$message.success("操作成功");
            if (callback) {
              callback();
            }
          },
          () => {
            this.confirmLoadding = false;
            this.$message.error("操作失败");
          }
        );
      } else {
        this.$post(
          "patientitem/patientItem/patientItemFolow?operateType=" + type,
          item,
          {
            "Content-Type": "application/json",
          }
        ).then(
          (res) => {
            this.$message.success("操作成功");
            if (callback) {
              callback();
            }
          },
          () => {
            this.confirmLoadding = false;
            this.$message.error("操作失败");
          }
        );
      }
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    getFileSuffix: function (name) {
      var index1 = name.indexOf(".");
      var index2 = name.length;
      var suffix = "";
      if (index1 != -1) {
        suffix = name.substring(index1 + 1, index2); //后缀名
      }
      return suffix;
    },
    getUpFqList(bid) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.fqData = [];
        self
          .$get("/uploadfq/uploadFq/getFqList", {
            bid: bid,
          })
          .then(
            (res) => {
              self.fqData = res.data.data;
              resolve(self.fqData);
            },
            (err) => {
              reject(err);
            }
          );
      });
    },
    // 表格操作下拉菜单
    menuClick(event, item) {
      const self = this;
      if (event.key.split("|").length == 2) {
        // 确认弹窗
        let keys = event.key.split("|");
        this.currentConfirmData = this[keys[1]][keys[0]];
        this.confirmVisible = true;
        this.selectData = item;
      } else if (event.key == "upload") {
        // 上传md5后上传fq
        this.uploadMd5(item);
      } else if (event.key == 7) {
        this.sureRows(event, item);
      } else {
        // 内容弹窗
        this.modelId = event.key;
        this.selectData = item;
        this.visible = true;
      }
    },
    uploadMd5(item) {
      this.$get("/uploadfq/uploadFq/check/md5", {
        id: item.id,
      }).then((res) => {
        if (res.data.data) {
          this.uploadFq(item);
        } else {
          this.$message.error("请先上传md5文件");
        }
      });
    },
    uploadFq(item) {
      const self = this;
      // 获取fq列表-小于2-选择fq文件-上传文件逻辑在components/layout
      self.getUpFqList(item.id).then((res) => {
        if (self.fqData.length >= 2) {
          self.$message.warning("已存在足够数量文件，不能再上传！");
        } else {
          document.getElementById("upload_" + item.id).onclick = function (
            fileEvent
          ) {
            fileEvent.stopPropagation();
          };
          document.getElementById("upload_" + item.id).click();
          document.getElementById("upload_" + item.id).onchange = function () {
            if (document.getElementById("upload_" + item.id).files.length > 0) {
              let fileObj = document.getElementById("upload_" + item.id)
                .files[0];
              document.getElementById("upload_" + item.id).value = "";
              let fileName =
                item.hosBarCode +
                "_" +
                item.barCode +
                "_" +
                item.applyItemName +
                "_R1_" +
                new Date().getTime() +
                "." +
                self.getFileSuffix(fileObj.name);
              const suffix = self.getFileSuffix(fileObj.name);
              const findSuffx = self.uploadSuffixs.find(
                (item) => item == suffix
              );
              if (!findSuffx) {
                self.$message.error(
                  "请上传指定后缀为fastq.gz,fq.gz,vcf,fastq,fq,idat的文件"
                );
                return;
              }
              self.$store.commit("file/setShowContainer", true);
              self.$store.commit("file/setFileList", [
                {
                  percent: 0,
                  title: fileObj.name,
                  type: "upload",
                  file: fileObj,
                  fileName: fileObj.name,
                  // fileName:fileName,
                  _data: item,
                },
              ]);
            }
          };
        }
      });
    },
    incrementClick(data) {
      this.handleDiagnosis(data, "added-item", () => {
        this.visible = false;
        this.getData();
      });
    },
    updateRowsPop() {
      this.rowsPop = true;
    },
    updateRows() {
      this.rows = null;
      this.rowsPop = false;
    },
    okClick() {
      // setTimeout(() => {
      //   this.confirmLoadding = false;
      // }, 1000);
      // return;
      if (this.currentConfirmData.operateType == "confirmed-requisition") {
        this.handleDiagnosis(
          this.selectRows,
          this.currentConfirmData.operateType,
          () => {
            this.confirmVisible = false;
            this.confirmLoadding = false;
            this.getData();
          }
        );
      } else {
        this.handleDiagnosis(
          this.selectData,
          this.currentConfirmData.operateType,
          () => {
            this.confirmVisible = false;
            this.confirmLoadding = false;
            this.getData();
          }
        );
      }
    },
    stopPropagation() {
      this.$nextTick(() => {
        document
          .querySelectorAll(".handle-more .hospital-dropdown-link")
          .forEach((ele) => {
            ele.onclick = function (event) {
              event.stopPropagation();
            };
          });
      });
    },
    editRows($event, item) {
      $event.stopPropagation();
      this.selectData = item;
      this.modelId = 1;
      this.visible = true;
    },
    sureRows($event, item) {
      if (item.trackingStatus != "added-item") {
        return;
      }
      this.currentConfirmData = this.confirmData.sureData;
      this.selectRows = [item];
      this.confirmVisible = true;
    },
    gethospitalLog() {
      this.$get("dept/findDeptTreeList", {
        pageSize: 10000,
        deptType: 2,
      }).then((res) => {
        const userInfo = this.$db.get("userInfo");
        this.sequencingData = res.data.data[0].children;
        if (!this.editData) {
          if (userInfo.deptId == null) {
            this.sequencingStatus = false;
          } else {
            this.sequencingData.forEach((item) => {
              if (item.deptId == userInfo.deptId) {
                this.deptId = userInfo.deptId + "";
                this.sequencingStatus = true;
              }
            });
          }
        } else {
          if (userInfo.deptId == null) {
            this.sequencingStatus = false;
          } else {
            this.sequencingData.forEach((item) => {
              if (item.deptId == userInfo.deptId) {
                this.sequencingStatus = true;
              }
            });
          }
        }
      });
    },
    exportExcelClick() {
      let params = {
        hosBarCodeOrBarCode: this.hosBarCodeOrBarCode,
        hospitalId: this.hospitalId,
        patientGroupId: this.patientGroupId,
        qualityStatus: this.qualityStatus,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        trackingStatus: this.trackingStatus,
        warning: this.warning,
        mdCheck: this.mdCheck,
        mdRead: this.mdRead,
        seqDeptId: this.seqDeptId,
        applyItem: this.applyItem,
      };
      params = this.deleteEmpty(params);
      if (params.warning) {
        params.warning = 1;
      }
      this.$export('/patientitem/patientItem/down', params, '就诊流程列表');
    },
    //请选择时间区间 导出
    onChangePicker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal = val;
        this.dowmOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
        };
      }
    },
    exportFile() {
      let url = "/apiLog/apiLog/downFail";
      let opt = this.dowmOpt;
      opt.formId = this.deptId;
      let dFilename = "uec_log_" + new Date().getTime() + ".txt";
      this.$download(url, opt, dFilename);
    },
    add() {
      this.selectData = null;
      this.modelId = 1;
      this.visible = true;
    },
    sureClick() {
      if (this.selectRows.length > 0) {
        let status = true;
        this.selectRows.forEach((item) => {
          if (item.trackingStatus != "added-item") {
            status = false;
          }
        });
        if (status) {
          this.currentConfirmData = this.confirmData.sureData;
          this.confirmVisible = true;
        } else {
          this.$message.warning("请选择跟踪状态为已增项的流程数据");
        }
      } else {
        this.$message.warning("请选择数据");
      }
    },
    batchAddClick() {
      this.modelId = 0;
      this.visible = true;
    },
    insertClick() {
      if (this.selectRows.length > 0) {
        this.modelId = 2;
        this.visible = true;
      } else {
        this.$message.warning("请选择数据后进行样本入库");
      }
    },
    closeConfirm() {
      this.confirmVisible = false;
      this.getData();
    },
    closeModel() {
      this.visible = false;
      this.getData();
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.getData();
    },
    deleteDiagnosis(item) {
      this.$delete("patientitem/patientItem", {
        ids: [item.id],
      }).then(
        (res) => {
          this.$message.success("删除数据成功");
          this.getData();
        },
        () => {
          this.$message.error("删除数据失败");
        }
      );
    },
    // 删除params里空值
    deleteEmpty(params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (!value || (Array.isArray(value) && value.length == 0)) {
          delete params[key];
        }
      });
      return params;
    },
    getData() {
      this.spinning = true;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.page,
        hosBarCodeOrBarCode: this.hosBarCodeOrBarCode,
        hospitalId: this.hospitalId,
        patientGroupId: this.patientGroupId,
        seqDeptId: this.seqDeptId,
        qualityStatus: this.qualityStatus,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        trackingStatus: this.trackingStatus,
        warning: this.warning,
        mdCheck: this.mdCheck,
        mdRead: this.mdRead,
        applyItem: this.applyItem,
      };
      params = this.deleteEmpty(params);
      localStorage.setItem("DIAGNOSIS_FILTER", JSON.stringify(params));
      if (params.warning) {
        params.warning = 1;
      }
      this.$get("patientitem/patientItem", params).then(
        (res) => {
          this.spinning = false;
          this.resData = res.data.data;
          this.data = this.resData.rows;
          this.selectRows = [];
          this.selectedRowKeys = [];
          this.stopPropagation();
        },
        () => {
          this.spinning = false;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.export-popover {
  .export-content {
    padding: 0px 10px 10px 10px;

    .tool-item {
      width: 260px;
      font-size: 12px;
    }

    .export-btn {
      margin-left: 15px;
      font-size: 12px;
    }
  }
}

.ant-dropdown-menu {
  padding: 0 0;
}

.sample-page {
  width: 100%;
  min-width: 1200px;

  .h-mdCheck {
    display: inline-block;
    padding: 0px 4px;
    color: #fff;
    background-color: #1890ff;
    line-height: 20px;
    font-size: 12px;
    border-radius: 2px;

    &.not {
      background-color: #c4c4c4;
    }
  }
}

.page-handle {
  height: 60px;
  background: #f8fbfb;
  padding: 0 40px;
  line-height: 60px;
  border-top: 1px solid rgba(240, 242, 245, 1);
  border-bottom: 1px solid rgba(240, 242, 245, 1);

  .right {
    float: right;
    height: 60px;

    .hospital-dropdown-link {
      margin-left: 25px;
    }

    .hospital-dropdown-link {
      color: #3e7ff7;
      font-size: 12px;
    }
  }

  .left {
    height: 60px;
    float: left;

    .ant-btn+.ant-btn {
      margin-left: 5px;
    }
  }
}

.page-content {
  padding: 20px 40px;
  background: #fff;

  /deep/ .clickrowstyle {
    td {
      background: #e6f7ff;
    }
  }

  .table-tr-handle {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(66, 142, 247, 1);

    .handle-btn {
      cursor: pointer;
    }

    .handle-line {
      margin: 0 10px;
    }

    .handle-more {
      /deep/ .iconfont {
        font-size: 18px;
      }
    }
  }

  .pagination {
    margin: 20px 0;
    text-align: right;
  }
}

.icon-checked {
  float: right;
  color: #4c84ff;
  line-height: 22px;
  margin-left: 10px;
}
</style>